import {UserAttributes, UserType} from "../types/user.type";
import stripeClient               from "../networkClients/stripe-client";
import {useUser}                  from "../context/UserProvider/UserProvider";
import apiClient                  from "../networkClients/api-client";


const updateUserSubscription = async (
    userEmail: string,
    stripeCustomerId: string,
    productId: string
) => {

    try {
        const body: {} = {
            "customer_email": userEmail,
            "action"        : "update-subscription-to-paid",
            "customer_id"   : stripeCustomerId,
            "product_id"    : productId,
        }
        const response = await stripeClient.post<any>("/", body);
        return response.data
    }
    catch (error) {
        console.error(error);
    }
}

const updateUserAttributes = async (
    email: string,
    attributes: UserAttributes
) => {
    try {
        // Clone the attributes object to avoid mutating the original input
        const updatedAttributes = {...attributes};

        // Check if "custom:app_settings" exists and is an object
        if (
            updatedAttributes["custom:app_settings"] &&
            typeof updatedAttributes["custom:app_settings"] === "object"
        )
        {
            // Convert "custom:app_settings" object to a JSON string
            updatedAttributes["custom:app_settings"] = JSON.stringify(
                updatedAttributes["custom:app_settings"]
            ) as unknown as typeof updatedAttributes["custom:app_settings"];
        }

        const body: {} = {
            "user_email": email,
            "action"    : "update-user-attributes",
            "attributes": updatedAttributes,
        };

        const response = await apiClient.post<any>("/cognitointegration", body);
        return response.data;
    }
    catch (error) {
        console.error("Error updating user attributes:", error);
    }
};


const CognitoUserService = {
    updateUserSubscription, updateUserAttributes,
}
export default CognitoUserService;